import { useEffect } from 'react';
import URLHelpers from './shared/url_helpers';
import { post } from '@reverbdotcom/commons/src/http_client';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

export function useItemTrackView(listingId, user: IUser) {
  useEffect(() => {
    if (listingId) {
      post(URLHelpers.productViewsPath(listingId), user, {});
    }
  }, [listingId]);
}
